import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

interface ParticipantInfo {
  firstName: string;
  lastName: string;
  email: string;
}

export function NewSession() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get("id");

  const [mentorSearch, setMentorSearch] = useState("");
  const [menteeSearch, setMenteeSearch] = useState("");
  const [selectedMentor, setSelectedMentor] = useState<ParticipantInfo | null>(
    null
  );
  const [selectedMentee, setSelectedMentee] = useState<ParticipantInfo | null>(
    null
  );
  const [showMentorDropdown, setShowMentorDropdown] = useState(false);
  const [showMenteeDropdown, setShowMenteeDropdown] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedMentor || !selectedMentee) {
      alert("Please select both a mentor and mentee from the dropdown lists");
      return;
    }
    if (sessionId) {
      navigate(`/coordinator/session/${sessionId}`, {
        state: { mentor: selectedMentor, mentee: selectedMentee },
      });
    }
  };

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-8 text-3xl font-bold">New Mentorship Session</h1>
      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="rounded-lg border bg-white p-6 shadow-sm">
          <h2 className="mb-4 text-xl font-semibold">Mentor Details</h2>
          <div className="space-y-4">
            <div className="relative">
              <label
                htmlFor="mentorSearch"
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Search Mentor
              </label>
              <input
                type="text"
                id="mentorSearch"
                value={mentorSearch}
                onChange={(e) => {
                  setMentorSearch(e.target.value);
                  setSelectedMentor(null);
                  setShowMentorDropdown(true);
                }}
                onFocus={() => setShowMentorDropdown(true)}
                className="w-full rounded-lg border px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-[#4CAF50]"
                placeholder="Search mentors..."
                required
              />
              {showMentorDropdown && (
                <div className="absolute z-10 mt-1 w-full rounded-lg border bg-white shadow-lg">
                  {/* Mentor search results would be mapped here */}
                  <div className="p-2 text-sm text-gray-500">
                    Type to search for mentors...
                  </div>
                </div>
              )}
            </div>
            {selectedMentor && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <div className="rounded-lg border bg-gray-50 px-3 py-2">
                    {selectedMentor.email}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="rounded-lg border bg-white p-6 shadow-sm">
          <h2 className="mb-4 text-xl font-semibold">Mentee Details</h2>
          <div className="space-y-4">
            <div className="relative">
              <label
                htmlFor="menteeSearch"
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Search Mentee
              </label>
              <input
                type="text"
                id="menteeSearch"
                value={menteeSearch}
                onChange={(e) => {
                  setMenteeSearch(e.target.value);
                  setSelectedMentee(null);
                  setShowMenteeDropdown(true);
                }}
                onFocus={() => setShowMenteeDropdown(true)}
                className="w-full rounded-lg border px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-[#4CAF50]"
                placeholder="Search mentees..."
                required
              />
              {showMenteeDropdown && (
                <div className="absolute z-10 mt-1 w-full rounded-lg border bg-white shadow-lg">
                  {/* Mentee search results would be mapped here */}
                  <div className="p-2 text-sm text-gray-500">
                    Type to search for mentees...
                  </div>
                </div>
              )}
            </div>
            {selectedMentee && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="mb-1 block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <div className="rounded-lg border bg-gray-50 px-3 py-2">
                    {selectedMentee.email}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="rounded-lg bg-[#4CAF50] px-6 py-3 font-medium text-white transition-colors hover:bg-[#45a049]"
          >
            Create Session
          </button>
        </div>
      </form>
    </div>
  );
}
